module.exports = "/packs/images/svg/facilities/library~06b8cca967c3153064ff92b8351e991d.svg";